<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Ping</h4>
          <el-form :model="pingForm" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :rules="checkPingForm"
            ref="pingForm"
            >
            <el-form-item label="Interface Selection:">
                <el-select v-model="pingForm.wanIndex" @change="wanChange" placeholder="Please select" style="width: 100%">
                    <el-option label="br0" value="0"></el-option>
                    <el-option v-for="item in netWanNamelsit" :key="item.index" :label="item.wanName" :value="item.index"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="Protocol Type:" prop="type">
                <el-select v-model="pingForm.protocol" :disabled="protocolDisable" placeholder="Please select" style="width: 100%">
                    <el-option label="IPv4" value="ping"></el-option>
                    <el-option label="IPv6" value="ping6"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Repeat time:" prop="times">
                <el-input v-model="pingForm.times" class="times" placeholder="(1~3)Time"></el-input>
            </el-form-item>
             <el-form-item label="Target Address:" prop="address">
                <el-input v-model="pingForm.address"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="sendData">Start</el-button>
            </el-form-item>
        </el-form>
     
       <div class="panel panel-default" style="margin: 30px 2.5%;"  v-show="pingResult !== ''">
            <div class="panel-heading">
                 Ping Test Results 
            </div>
            <div class="textb" v-html="pingResult"></div>
        </div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            protocolDisable:false,
            wanList:[],
            pingForm:{
                wanIndex:'0', // 0 => br0
                protocol:'ping',
                times: '1',
                address:''
            },
            checkPingForm:{
                address:[{
                    validator: (rule, value, callback) => {
                        const protocol = this.pingForm.protocol == "ping" ? 4 : 6
                        const egText = this.pingForm.protocol == "ping" ? '192.168.1.100' : '1200::100'
                        if (!validator.isIP(value, protocol) && !validator.isFQDN(value)) {
                            callback(new Error(`Target Address Error!e.g. ${egText}`));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],
                times:[
                    {
                        validator: (rule, value, callback) => {
                            if (!validator.isInt(value, { min: 1, max: 3})) {
                                callback(new Error('Repeat time Error!must rang [1~3]'))
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ]
            },
            pingResult:''
        }
    },
    created(){
        this.getData()
    },
    computed: {
        netWanNamelsit() {
            let name = []
            this.wanList.forEach(e =>{
                if(e.mode === '0' && 
                ( e.serviceType === '0' || e.serviceType === '1' || e.serviceType === '6' || e.serviceType === '7') )
                {
                    name.push({wanName:e.wanName,index:e.index})
                }
            })
            return name
        }
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/boafrm/fhWANService",{CmdType:"GET_WAN"})
            .then((response)=>{
                this.loading = false                
                if(response.data.ret === 0)
                {
                    this.wanList = response.data.wanLists
                }
                else
                {
                    this.$message.error(`GET data failed! Error:${response.data.errorMsg}`)
                }
            })
        },
        setData() {
            this.loading = true
            axios
            .post("/boafrm/fhPingInfo",{
                CmdType:"START_PING",
                interface: this.pingForm.wanIndex,
                protocolType: this.pingForm.protocol,
                targetNum: this.pingForm.times,
                targetAddr: this.pingForm.address
            })
            .then((response)=>{
                this.loading = false                
                if(response.data.ret === '0')
                {
                    this.pingResult = response.data.pingResults
                }
                else
                {
                    this.$message.error(`Ping test failed! Error:${response.data.errorMsg}`)
                }
            })
        },
        wanChange(val){
            this.protocolDisable = false
            if(this.wanList[val - 1] && this.wanList[val - 1].protocolType === '1')
            {
                this.protocolDisable = true
                this.pingForm.protocol = 'ping'
            }
                
        },
        sendData(){
            this.$refs["pingForm"].validate(valid => {
                if(valid)
                {
                    this.setData()
                }

            })
        }
    },
}
</script>
<style lang="scss" scoped>
.time {
  color: #737373;
  float: left;
}
textarea {
  resize: none;
  width: 100%;
  height: 200px;
}
.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.textb {
  padding: 15px;
}
</style>





